import React from 'react';

class InfinityCardSection extends React.Component {
  render() {
    const {
      sectionHeading = '',
      iterable,
      onAddNew,
      Card,
      cardProps = {},
      NewCard,
      max = 999
    } = this.props;
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">{sectionHeading}</h3>
          </div>
        </div>
        <div className="infinity-cards">
          {iterable.map((item, key) => (
            <Card key={key} index={key} item={item} {...cardProps} />
          ))}
          {iterable.length < max && NewCard && <NewCard onClick={onAddNew} />}
        </div>
      </div>
    );
  }
}
export default InfinityCardSection;



// WEBPACK FOOTER //
// ./src/components/shared/InfinityCardSection.js